import React from "react";
import {
  Box,
  ButtonGroup,
  IconButton,
  List,
  Pagination,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { Delete, Edit } from "@mui/icons-material";
import { useDispatch } from "react-redux";
import { PaginationDetails } from "../../Utils/Utils";
import styles from "./BrPriv.module.css";
import {
  openDeleteBrPrivModal,
  openEditBrPrivModal,
} from "../../Store/Slices/brPrivSlice";
import { useState } from "react";
import { useEffect } from "react";

const BrPrivTable = ({ data }) => {
  const dispatch = useDispatch();

  const { page, count, handleChange, _DATA } = PaginationDetails(data);
  const [roles, setRoles] = useState("");

  useEffect(() => {
    const getRoles = () => {
      if (typeof window !== undefined) {
        setRoles(sessionStorage.getItem("role"));
      }
    };
    getRoles();
  }, []);

  return (
    <>
      <TableContainer className={styles.container}>
        <Table
          stickyHeader
          aria-label="br privilege mappings table"
          className={styles.table}
        >
          <TableHead>
            <TableRow>
              <TableCell width={100}>Id</TableCell>
              <TableCell width={200}>Role</TableCell>
              <TableCell width={200}>Privilege</TableCell>
              <TableCell align="center" width={"30%"}>
                Action
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {_DATA.currentData()?.map((mapping) => (
              <TableRow className={styles.row} key={mapping.brId}>
                <TableCell className={styles.tCell} component="th" scope="row">
                  #{mapping.brId}
                </TableCell>
                <TableCell className={styles.tCell}>{mapping.brName}</TableCell>
                <TableCell className={styles.tCell}>
                  <List>
                    {mapping.priv?.map((priv) => (
                      <Typography key={priv.privId}>{priv.privName}</Typography>
                    ))}
                  </List>
                </TableCell>
                <TableCell className={styles.tCell} align="center">
                  <ButtonGroup variant="text" aria-label="text button group">
                    {roles.split(",").includes("PRIV_ECOM_EDITMAPPING") && (
                      <IconButton
                        onClick={() => {
                          dispatch(openEditBrPrivModal(mapping.brId));
                        }}
                      >
                        <Edit />
                      </IconButton>
                    )}
                    {roles.split(",").includes("PRIV_ECOM_DELETEMAPPING") && (
                      <IconButton
                        onClick={() => {
                          dispatch(openDeleteBrPrivModal(mapping.brId));
                        }}
                      >
                        <Delete />
                      </IconButton>
                    )}
                  </ButtonGroup>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Box my={2} display="flex" justifyContent="center">
        <Pagination
          count={count}
          size="large"
          page={page}
          variant="outlined"
          color="primary"
          onChange={handleChange}
          className={styles.pagination}
        />
      </Box>
    </>
  );
};

export default BrPrivTable;
